








































































/* 용어에 대한 정의 근거

////////////  인벤토리 === 플레이스먼트 /////////////////
플레이스먼트는 우리 사내에서 주로 사용 중.
플레이스먼트와 인벤토리 업계에서 모두 사용되고 있음. ex) AdMob 은 placement 등등..

그러나 전반적으로 인벤토리가 좀 더 많이 이용되고 있는 것으로 보임.
따라서 페이지 제공은 inventory로 통일하였음.
*/
import _ from 'lodash';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { DefaultOption, TableOptionType  } from '@/const/options/DefaultTableOption';

import { Report as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { ReportConfirm } from '@/const/terms/feedback/confirm';
import { ReportDefault as feedbackTerms } from '@/const/terms/feedback/report';

import { STATUS } from '@/const/status/index';
import { IAPP, IINVENTORY_RESPONSE, IINVENTORY_RESPONSE_IN_APP, ID_TYPE, IAPP_RESPONSE } from '@/const/types';
import {
    HourlyAppReportsType,
    HourlyPlacementReportWrapsType,
    HourlyPlacementReportTerminalsType,
    HourlyAppReportResponse,
    IHourlyAppReport,
    IHourlyPlacementReportWrap,
    IHourlyPlacementReportTerminal,
    HourlyRowType,
    HourlyRootRowType,
    HourlySingleTerminalRowItemType,
    HourlySingleRootRowItemType,
} from './types';
import {
    ISearchFormType
} from '../types'
import { TUI_FORMAT } from '@/utils/toastGrid_formatter';
import { Grid } from '@toast-ui/vue-grid';
import { IGridOptions, DefaultGridOptions, DefaultColumnOptions, GroupColumnOptions, NumberColumnOptions } from '@/const/options/TuiGridTypes';

import { ORIGIN_FORMAT } from '@/utils';
import { AxiosError, AxiosResponse } from 'axios';

import Select from '@/components/ElementComponent/Select/index.vue';
import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import DateRangePicker from '@/components/ElementComponent/Date/DateRangePicker.vue';
import GridInventoryReport from '@/components/pages/report/inventory/GridInventoryReport.vue';

@Component<ReportInventoryHourly>({
    name: 'ReportInventoryHourly',
    components: {
        GridInventoryReport,
        DateRangePicker,
        Select,
    },
})
export default class ReportInventoryHourly extends Vue {
    private terms = terms;
    private compTerms = compTerms;
    private confirmTerms = ReportConfirm;
    
    private loading: boolean = false;
    private subLoading: number = 0;
    private reportLoading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private isAllExpanded: number = 0; // 0 all collapsed, 1 app expanded, 2 all expanted
    private allExpandToggleConfirmVisible: boolean = false;
    private dateValue: Date[] = [new Date(), new Date()];
    private statusOptions: { value: STATUS; label: string; }[] = [
        { value: STATUS.ALL, label: '모든 상태' },
        { value: STATUS.ACTIVE, label: '활성' },
        { value: STATUS.INACTIVE, label: '비활성' },
    ];
    private appOptions: SelectOptionType<IAPP>[] = [];
    private inventoryList: IINVENTORY_RESPONSE[] = [];
    get inventoryOptions(): SelectOptionType<IINVENTORY_RESPONSE>[] {
        if (this.filterForm.app.length === 0) {
            return this.inventoryList.map((inv: IINVENTORY_RESPONSE) => ({
                label: inv.name,
                value: inv,
            } as SelectOptionType<IINVENTORY_RESPONSE>))
                .sort((a: SelectOptionType<IINVENTORY_RESPONSE>, b: SelectOptionType<IINVENTORY_RESPONSE>) => a.label < b.label ? -1 : 1);
        } 
        const appKeys = this.filterForm.app.map((app: IAPP) => app.key) as ID_TYPE[];
        const invIDs  = this.filterForm.inventory.map((inv: IINVENTORY_RESPONSE) => inv.id) as ID_TYPE[];
        return this.inventoryList.filter((inv: IINVENTORY_RESPONSE) => (appKeys.includes(inv.app_key) || invIDs.includes(inv.id)))
            .map((inv: IINVENTORY_RESPONSE) => ({
                label: inv.name, 
                value: inv,
            } as SelectOptionType<IINVENTORY_RESPONSE>))
                .sort((a: SelectOptionType<IINVENTORY_RESPONSE>, b: SelectOptionType<IINVENTORY_RESPONSE>) => a.label < b.label ? -1 : 1);
    }
    
    private filterForm: ISearchFormType = { status: STATUS.ALL, app: [], inventory: [] };

    private tableData: HourlyAppReportsType = [];
    private tableOptions: TableOptionType = DefaultOption;
    

    
    get expandButtonContent() {
        const num = this.isAllExpanded;
        return (
            (num === 0 ? '모든 앱' : (num === 2 ? '모두' : '모든 인벤토리'))
            +
            (num === 2? ' 접기' : ' 펼치기')
        );
    }
    private toggleAllHandler() {
        this.allExpandToggleConfirmVisible = false;
        if (this.loading || this.subLoading > 0) {
            return;
        }
        const gridWrapper = this.$refs.gridWrapper as GridInventoryReport;
        const table = gridWrapper.$refs.table as Grid;
        const rows = table.invoke('getRows') as HourlyRowType[];
        this.loading = true;
        // setTimeout(() => {
            if (this.isAllExpanded === 2) {
                // rows.forEach((item: any) => {
                //     const row = item as HourlyRootRowType;
                //     if (row._children === true
                //         || (row._treeData !== undefined && (row._treeData as any).childrenRowKeys && (row._treeData as any).childrenRowKeys.length !== 0) 
                //         || (row._children !== undefined && row._children !== false)
                //     ) {
                //         table.invoke('collapse', row.rowKey, true);
                //     }
                // })
                this.isAllExpanded = 0;
                table.invoke('collapseAll');
            } else {
                this.isAllExpanded = 1;
                rows.forEach((item: any) => {
                    const row = item as HourlyRootRowType;
                    // if (row._children === true
                    //     || (row._treeData !== undefined && (row._treeData as any).childrenRowKeys && (row._treeData as any).childrenRowKeys.length !== 0) 
                    //     || (row._children !== undefined && row._children !== false)
                    // ) {
                    //     table.invoke('expand', row.rowKey, true);
                    // }
                    if (row.dateRange) {
                        this.isAllExpanded = 2;
                    } 
                })
                table.invoke('expandAll');
            }
            this.loading = false;
        // })
    }

    private expandedHandler({ rowKey, descendantRowKeys, instance }: tuiGrid.IColumnEventOptions & { descendantRowKeys: number[] | string[] | undefined[] }) {
        const gridWrapper = this.$refs.gridWrapper as GridInventoryReport;
        const table = gridWrapper.$refs.table as Grid;
        const row = table.invoke('getRow', rowKey) as HourlyRowType;
        const originRow = this.tableData.find((item: IHourlyAppReport) => item.id === row.id);
        if (descendantRowKeys.length === 0 && row._children === true && originRow && originRow.isLoading !== true) {
            this.subLoading++;
            originRow.isLoading = true;
            this.getPlacementReport(row.id).then((res: any) => res.data)
                .then((data: HourlyPlacementReportTerminalsType) => {
                    const groupMap = _.groupBy(data, "id");
                    const rowData = [] as HourlyPlacementReportWrapsType;
                    Object.values(groupMap).forEach((item: IHourlyPlacementReportTerminal[]) => {
                        const name = item[0].name;
                        const {totalRequest, adServerImp, adServerFreeImp, /*sspImp,*/ click, revenue } = item
                            .sort((a: IHourlyPlacementReportTerminal,b: IHourlyPlacementReportTerminal) => a.date < b.date ? 1 : -1)
                            .reduce( (pre: {[key: string]: number}, curr: IHourlyPlacementReportTerminal) => {
                                const isOdd = new Date(curr.date).getDate() % 2;
                                delete curr.name;
                                curr._extraData = {
                                    className: {
                                        row: ['tuiGridTreeTerminal', (isOdd ? 'tuiGridTreeTerminalHighlight02' : 'tuiGridTreeTerminalHighlight01')]
                                    },
                                }
                                curr.totalImp = curr.adServerImp + curr.adServerFreeImp /*+ curr.sspImp*/;
                                curr.adServerImpRate = curr.totalRequest === 0 ? -1 : curr.adServerImp / curr.totalRequest * 100;
                                curr.ctr = curr.totalImp === 0 ? -1 : curr.click / curr.totalImp * 100;
                                return {
                                    totalRequest: pre.totalRequest + curr.totalRequest,
                                    adServerImp: pre.adServerImp + curr.adServerImp,
                                    adServerFreeImp: pre.adServerFreeImp + curr.adServerFreeImp,
                                    // sspImp: pre.sspImp + curr.sspImp,
                                    click: pre.click + curr.click,
                                    revenue: pre.revenue + curr.revenue,
                                }
                            }
                        , {totalRequest: 0, adServerImp: 0, adServerFreeImp: 0, /*sspImp: 0,*/ click: 0, revenue: 0})

                        const totalImp = adServerImp + adServerFreeImp /*+ sspImp*/;
                        const adServerImpRate = totalRequest === 0 ? -1 : adServerImp / totalRequest * 100;
                        const ctr = totalImp === 0 ? -1 : click / totalImp * 100;

                        const newRow = {
                            id: item[0].id,
                            status: item[0].status,
                            name: name,
                            dateRange: _.cloneDeep(this.dateValue),
                            totalRequest: totalRequest,
                            adServerImp: adServerImp,
                            adServerFreeImp: adServerFreeImp,
                            // sspImp: sspImp,
                            click: click,
                            ctr: ctr,
                            revenue: revenue,
                            totalImp: totalImp,
                            adServerImpRate: adServerImpRate,
                            _children: item,
                        } as IHourlyPlacementReportWrap;
                        rowData.push(newRow);
                    })
                    return rowData.sort((a: IHourlyPlacementReportWrap, b: IHourlyPlacementReportWrap) => a.name < b.name ? -1 : 1);
                })
                .then((data: HourlyPlacementReportWrapsType) => {
                    table.invoke('addRowClassName', rowKey, 'tuiGridTreeRoot');
                    table.invoke('addCellClassName', rowKey, 'name', 'tuiGridTreeRoot');
                    if (data.length === 0) {
                        data.push({name: '리포트가 없습니다.'} as IHourlyPlacementReportWrap);
                    }
                    data.forEach((item) => {
                        item._extraData = {
                            className: {
                                row: ['tuiGridTreeTerminalWrapper'],
                            },
                        };
                    });
                    // setTimeout(() => {
                        table.invoke('appendRow', data as HourlySingleRootRowItemType, { parentRowKey: rowKey });
                        this.subLoading--;
                        originRow.isLoading = false;
                    // })
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                    }
                    throw err;
                })
        }
    }
    private toggleUtilCollapsed() {
        this.isUtilsCollapsed = !this.isUtilsCollapsed;
        this.$nextTick(this.resizeHandler);
    }
    private refreshData(date: Date[]) {
        if (date) {
            this.getAppReportHandler();
        }
    }
    
    private excelDownloadHandler() {
        this.subLoading++;
        const gridWrapper = this.$refs.gridWrapper as GridInventoryReport;
        const table = gridWrapper.$refs.table as Grid;
        const columns = table.invoke('getColumns') as tuiGrid.IColumnInfoOptions[];
        const json = JSON.stringify(table.invoke('getRows') as HourlyRowType[]);
        const refinedJson = json
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>.[<>a-zA-Z0-9 =\\\/"-]*.<[/]span>/g, '')
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>/g, '')
                .replace(/<i.[\s\S].[a-z]*=.[a-z\"\\-]*><\/i>/g, '')
                .replace(/<\/span>/g, '');
        const rows = JSON.parse(refinedJson) as HourlyRowType[];
        let content = "";
        let cnt = 0;
        const keys: string[] = columns.map((item: tuiGrid.IColumnInfoOptions) => item.name);
        columns.forEach((item: tuiGrid.IColumnInfoOptions, index: number) => {
            if (index !== 0) content += ',';
            content += '"' + item.title + '"';
        });
        rows.forEach((item: HourlyRowType) => {
            content += '\n';
            const isParagraph = 
                (item['_treeData' as keyof HourlyRowType] as any)['childrenRowKeys'] &&
                !(item['_treeData' as keyof HourlyRowType] as any).hasOwnProperty('parentRowKey')

            if (isParagraph) {
                content += '\n';
            }
            keys.forEach((key: string, index: number) => {
                if (index !== 0) content += ',';

                content += '"';
                const checkNum = Number.parseFloat(item[key as keyof HourlyRowType] as string);
                if (key.toLowerCase().includes('date')) {
                    if (item.hasOwnProperty('date')) {
                        content += moment(item['date' as keyof HourlyRowType] as string).format('YYYY.MM.DD HH시');
                    } else if (item.hasOwnProperty('dateRange')) {
                        const dateRange = (item['dateRange' as keyof HourlyRowType] as any) as Date[];
                        content += moment(dateRange[0]).format('YYYY.MM.DD') + ' ~ ' + moment(dateRange[1]).format('YYYY.MM.DD');
                    }
                } else if ( key.toLowerCase() === 'ctr' || key.toLowerCase() === 'adServerImpRate'.toLowerCase() ) {
                    if (Number.isNaN(checkNum) || checkNum === -1) {
                        content += ' - ';
                    } else {
                        content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                    }
                } else if (!Number.isNaN(checkNum)) {
                    content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                } else if (item[key as keyof HourlyRowType]){
                    content += item[key as keyof HourlyRowType];
                }
                content += '"';
            })
            if (isParagraph) {
                cnt++;
                content += ",,** "+cnt+`${item.name ? '. ' + item.name : ''}` +" **";
            }
        })
        const BOM = "\uFEFF";
        content = BOM + content
        const url = window.URL.createObjectURL(new Blob([content], {type: "text/csv"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `[${terms.inventory.hourly.title}]_${moment(this.dateValue[0]).format('YYYY-MM-DD')}_${moment(this.dateValue[1]).format('YYYY-MM-DD')}.csv`)
        link.click();
        this.subLoading--;
        return;
    }
    private resizeHandler() {
        const gridWrapper = this.$refs.gridWrapper as GridInventoryReport;
        const table = gridWrapper.$refs.table as Grid;
        table.invoke('refreshLayout');
    }
    
    private getAppReportHandler() {
        this.subLoading++;
        this.reportLoading = true;
        const start = this.dateValue[0];
        const end = this.dateValue[1];

        this.getAppReport().then((res: any) => res.data)
            .then( (data: HourlyAppReportResponse) => {
                this.tableData = data.map( (item: IHourlyAppReport) => {
                    const totalImp = item.adServerImp + item.adServerFreeImp /*+ item.sspImp*/;

                    const adServerImpRate = item.totalRequest === 0 ? -1 : (item.adServerImp / item.totalRequest) * 100;
                    const ctr = totalImp === 0 ? -1 : (item.click / totalImp) * 100;
                    return {
                        ...item,
                        totalImp: totalImp,
                        adServerImpRate: adServerImpRate,
                        ctr: ctr,
                        _children: true,
                        isLoading: false,
                    } as IHourlyAppReport;
                })
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.subLoading--;
                this.reportLoading = false;
                this.isAllExpanded = 0;
            })
    }
    private getInitialDataHandler() {
        this.subLoading++;
        this.loading = true;
            this.getAppData().then((res: any) => res.data)
                .then((data: IAPP_RESPONSE[]) => {
                    this.appOptions = data.map((item: IAPP_RESPONSE) => {
                        return {
                            label: item.name,
                            value: item,
                        } as SelectOptionType<IAPP>;
                    })
                        .sort((a: SelectOptionType<IAPP>, b: SelectOptionType<IAPP>) => a.label < b.label ? -1 : 1);
                    this.inventoryList = data.reduce((pre: IINVENTORY_RESPONSE[], curr: IAPP_RESPONSE) => {
                        curr.inventory.forEach((inv: IINVENTORY_RESPONSE_IN_APP) => {
                            (inv as IINVENTORY_RESPONSE).app_key = curr.key;
                        })
                        return [...pre, ...curr.inventory] as IINVENTORY_RESPONSE[];
                    }, []);
                })
            .catch((err: AxiosError) => {
                if(err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {
                this.subLoading--;
                this.loading = false;
                this.isAllExpanded = 0;
            })  
    }
    private getPlacementReport(appKey: ID_TYPE) {
        return  this.$http.adserverAPI.post('GetSSPPlacementReport', {
                    since: moment(this.dateValue[0]).format('YYYYMMDD'),
                    until: moment(this.dateValue[1]).format('YYYYMMDD'),
                    app: appKey,
                    status: this.filterForm.status,
                    inventory: this.filterForm.inventory
                                    .filter((inv: IINVENTORY_RESPONSE) => inv.app_key.toString() === appKey.toString())
                                    .map((inv: IINVENTORY_RESPONSE) => inv.id),
                    period: 'hour',
                }, { withUniqueCanceler: true })
    }

    private getAppReport() {
        const inventoryApps = new Set<ID_TYPE>();
        this.filterForm.inventory.forEach((inv: IINVENTORY_RESPONSE) => inventoryApps.add(inv.app_key));
        this.filterForm.app.forEach((app: IAPP) => inventoryApps.add(app.key));
        const apps = [] as ID_TYPE[];
        inventoryApps.forEach((id: ID_TYPE) => apps.push(id));

        return this.$http.adserverAPI.post('GetSSPAppReport', {
            since: moment(this.dateValue[0]).format('YYYYMMDD'),
            until: moment(this.dateValue[1]).format('YYYYMMDD'),
            app: apps,
            status: this.filterForm.status,
            period: 'hour',
        })
    }

    private getAppData() {
        return this.$http.adserverAPI.post('GetSSPAppList')
    }

    private mounted() {
        this.$nextTick( () => {
            this.getInitialDataHandler();
            this.getAppReportHandler();
        })
    }
}
